import React from 'react'
import { useAuth } from '../../AuthContext'

function PinterestConnect() {
    const myContext = useAuth();

    const handlePinterestConnect = () => {
        const clientId = "1550238"; 
        const redirectUri = encodeURIComponent("https://api.schedpilot.com/wp-json/api/v1/pinterest-callback");
        
        // Ensure user_accounts:read is present to get the profile picture
        const scope = "boards:read,boards:write,lists:read,lists:write,media:read,media:write,pins:read,pins:write,user_accounts:read";
        const pinterestUrl = `https://www.pinterest.com/oauth/?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`;

        const width = 600, height = 700;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
    
        const authWindow = window.open(
            pinterestUrl,
            'PinterestAuth',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );
    
        const messageHandler = (event) => {
            // Check origin for security if possible: if (event.origin !== "https://api.schedpilot.com") return;
            
            if (event.data.type === "pinterest-authenticated") {
                // Extracting all the new data from your PHP callback
                const { 
                    token, 
                    refreshToken, 
                    expiresIn, 
                    refreshExpiresAt, 
                    profileImage, 
                    username 
                } = event.data;
    
                fetch('https://api.schedpilot.com/wp-json/api/v1/register-pinterest-token', {
                    method: 'POST',
                    credentials: 'include', 
                    headers: {
                        'Content-Type': 'application/json', 
                    },
                    body: JSON.stringify({ 
                        pinterestToken: token,
                        refreshToken: refreshToken,
                        expiresIn: expiresIn,
                        refreshExpiresAt: refreshExpiresAt,
                        profileImage: profileImage,
                        username: username
                    })
                })
                .then(data => data.json())
                .then(MYJSON => {
                    myContext.getAccountsData();
                    if (authWindow) authWindow.close();
                })
                .catch(err => console.error("Error registering token:", err));

                window.removeEventListener("message", messageHandler);
            }
        };

        window.addEventListener("message", messageHandler);
    
        const interval = setInterval(() => {
            if (authWindow && authWindow.closed) {
                clearInterval(interval);
                window.removeEventListener("message", messageHandler);
            }
        }, 1000);
    };

    return (
        <button className='btn btn-danger' onClick={handlePinterestConnect}>
            <i className="fab fa-pinterest mr-2"></i> Connect Pinterest
        </button>
    );
}

export { PinterestConnect };